import { UserRewardJsonldSeasonPassRead } from '@/api/generated';
import MosaicItem from '@/molecules/MosaicItem/MosaicItem';
import ModalClassicLayout from 'context/Modal/layout/Classic';

interface Props {
  closeModal: () => void;
  userRewards?: UserRewardJsonldSeasonPassRead[];
}

const SeasonPassRewardsModal = ({ closeModal, userRewards }: Props) => (
  <ModalClassicLayout closeModal={closeModal} title="seasonPass.myRewards">
    <div className="grid-12 items-end gap-x-2">
      {userRewards?.map((reward) => {
        const card = reward.reward?.card;
        const rarity = card?.rarity?.reference;

        return (
          !!card && (
            <MosaicItem
              key={reward['@id']}
              cardRef={card.reference}
              className="xl:col-span-3 sm:col-span-3 col-span-6"
              imagePath={card.imagePath}
              name={card.name}
              rarity={rarity}
            />
          )
        );
      })}
    </div>
  </ModalClassicLayout>
);

export default SeasonPassRewardsModal;
